// extracted by mini-css-extract-plugin
export var overlay = "LoadingOverlay-module--overlay--7e936";